<template lang="pug">
  .info.addon.relative
    button.absolute.cross(@click='hideInfo')
      simple-svg(:filepath='crossIcon' width='15px' height='15px')
    .row
      simple-svg.m4-top-2(:filepath='bulbIcon' width='25px' height='25px')
      .column.m-left-1.info-container
        h2.text-normal.bold.m4-bottom-2 {{ info.title }}
        ul.tips
          li.row.tip(v-for='item in info.tips')
            h2.text-normal.dark-gray.m4-left-3(v-html='item')
        .row.middle.m-top-1(v-if='guideLinkArray' v-for='item in info.guideLink')
          simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' width='16px' height='16px')
          a.blue.text-small(target='_blank' rel='noreferrer noopener' :href='item.link') {{ item.msg }}
        .row.middle.m-top-1(v-if='guideLinkObject')
          simple-svg.blue-icon.m-right-1(:filepath='downloadIcon' width='16px' height='16px')
          a.blue.text-small(target='_blank' rel='noreferrer noopener' :href='info.guideLink.link') {{ info.guideLink.msg }}
</template>

<script>
import bulbIcon from '@/assets/krea/ic_bulb.svg'
import downloadIcon from '@/assets/ic_download.svg'
import crossIcon from '@/assets/ic_cross.svg'
import { mapState } from 'vuex'

export default {
  props: {
    info: { type: Object }
  },
  data() {
    return {
      crossIcon,
      downloadIcon,
      bulbIcon
    }
  },
  computed: {
    ...mapState({
      innerLocale: state => state.behavior.innerLocale
    }),
    kreaContentGuide() {
      return process.env[`VUE_APP_KREA_CREATE_CONTENT_GUIDE_${this.innerLocale}`]
    },
    guideLinkArray() {
      return this.info.guideLink && Array.isArray(this.info.guideLink)
    },
    guideLinkObject() {
      return this.info.guideLink && !Array.isArray(this.info.guideLink)
    }
  },
  methods: {
    hideInfo() {
      this.$emit('hideInfo')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.info{
  background-color: $white;
  border: 1px solid $black;
  padding: 10px;
  bottom: 100%;
  width: 350px;
  border-radius: 5px;
}
.info-container{
  padding: 5px;
}

.tips{
  &>:not(:last-child){
    margin-bottom: 4px;
  }
}

.tip{
  position: relative;
  &::after{
    content: "";
    border-radius: 50%;
    width: 6px;
    height: 6px;
    background-color: $dark-gray;
    position: absolute;
    margin-top: 6px;
    margin-right: 5px;
  }
}

.cross{
  top: 10px;
  right: 10px;
}
</style>
